import React, { createContext, useContext, useEffect } from "react";

/**
 * Voxly — ThemeProvider.
 *
 * Locked to the original orange + black dark theme by product decision.
 * The light theme experiment landed badly; this provider forces dark on
 * every mount and clears any stale `voxly-theme` value from localStorage.
 *
 * `useTheme()` still returns `{ theme, toggleTheme }` (toggleTheme is a
 * no-op) so existing imports compile without changes.
 */
const ThemeContext = createContext({ theme: "dark", toggleTheme: () => {} });

export function ThemeProvider({ children }) {
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", "dark");
    try { localStorage.removeItem("voxly-theme"); } catch { /* SSR / private-mode safety */ }
  }, []);

  return (
    <ThemeContext.Provider value={{ theme: "dark", toggleTheme: () => {} }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
